/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const BackupEnum = {
    GET_BACKUP: '/backup',
    POST_BACKUP_UPLOAD: '/backup/upload',
    GET_BACKUP_LIST: '/backup/list',
    POST_BACKUP_RESTORE: '/backup/restore',
    POST_HEALTHCHECK_SCRIPT: '/healthchecks',
    GET_ALL_EXTERNAL_CHECK_SCRIPTS: '/healthchecks/',
    GET_EXTERNAL_SCRIPTS_BY_SERVICE: (service: string): string => {
        return '/healthchecks/service/' + service;
    },
    GET_EXTERNAL_SCRIPT_BY_ID: (id: string): string => {
        return '/healthchecks/' + id;
    },
    PUT_EXTERNAL_CHECK_SCRIPTS: (id: string): string => {
        return '/healthchecks/' + id;
    },
    DELETE_EXTERNAL_CHECK_SCRIPTS: (id: string): string => {
        return '/healthchecks/' + id;
    },
    GET_STICKTABLE: (backend: string, start: number, end: number): string => {
        return `/haproxy/sticktable/${backend}/${start}/${end}`;
    },
    DELETE_STICKTABLE: (backend: string): string => {
        return '/haproxy/sticktable/' + backend;
    },
    DELETE_STICKTABLE_ITEM: (backend: string, type: string, key: string): string => {
        return `/haproxy/sticktable/${backend}/${type}/${key}`;
    }
};
